<div [formGroup]="formGroup">
  <siat-select-field
    formControlName="struttura"
    id="id"
    name="name"
    [label]="label || ('SANITARIO.strutturaLabel' | translate)"
    [placeholder]="placeholder || ('SANITARIO.strutturaPlaceholder' | translate)"
    [items]="itemsStrutture()"
  ></siat-select-field>
</div>